import { IField } from '../form';
import { IListBase } from '../list';
import { FileType } from '../file';
import { SelectorItem } from '../components/Selector';

import {
  ParseMessageDateFilterFormat,
  ParseMessageDateFilterType,
  ParseMessageDateTimeFilterFormat,
  ParseMessageFilterType,
  ParseMessageNumberFilterDecimalSep,
  ParseMessageTimeFilterFormat
} from './server';

export enum ParseMessageTab {
  common = 'common',
  attachments = 'attachments'
}

export interface IParseMessageNumberFilter {
  kind: ParseMessageFilterType.number;
  min: string;
  max: string;
  decimalSep: ParseMessageNumberFilterDecimalSep;
  // только целые числа
  integer: boolean;
}

export interface IParseMessageStringFilter {
  kind:
    | ParseMessageFilterType.word
    | ParseMessageFilterType.string
    | ParseMessageFilterType.phone
    | ParseMessageFilterType.email;
  min: string;
  max: string;
}

export interface IParseMessageRegExFilter {
  kind: ParseMessageFilterType.regex;
  regexp: string;
}

export interface IParseMessageGroup {
  key: string;
  target: IField<string | null>;
  filter:
    | IParseMessageNumberFilter
    | IParseMessageStringFilter
    | IParseMessageRegExFilter
    | IParseMessageDateFilter<ParseMessageFilterType.date>
    | IParseMessageDateFilter<ParseMessageFilterType.datetime>
    | IParseMessageDateFilter<ParseMessageFilterType.time>;
  filterType: ParseMessageFilterType;
}

export interface IParseTextBase {
  expr: string;
  groups: IListBase<IParseMessageGroup>;
}

export interface IParseText extends IParseTextBase {
  source: string;
}

export interface IParseAttachments {
  readonly types: IField<FileType[]>;
  readonly countData: IParseAttachmentsFloatCount | IParseAttachmentsExactCount;
  // переменная типа list
  readonly target: IField<string | null>;
  readonly maxSize: IField<number | null>;
  readonly countType: IField<ParseAttachmentsCountType>;
}

export enum ParseAttachmentsCountType {
  exact = 'exact',
  float = 'float'
}

export interface IParseAttachmentsExactCount {
  type: ParseAttachmentsCountType.exact;
  count: IField<string>;
}

export interface IParseAttachmentsFloatCount {
  type: ParseAttachmentsCountType.float;
  minCount: IField<string>;
  maxCount: IField<string>;
}

export const parseAttachmentsCountTypeEntities: Record<
  ParseAttachmentsCountType,
  SelectorItem
> = {
  [ParseAttachmentsCountType.exact]: {
    id: ParseAttachmentsCountType.exact,
    title: (t) =>
      t('block.ActionUserInput.parseAttachmentsCountTypeEntities.exact', {
        ns: 'entities'
      })
  },
  [ParseAttachmentsCountType.float]: {
    id: ParseAttachmentsCountType.float,
    title: (t) =>
      t('block.ActionUserInput.parseAttachmentsCountTypeEntities.float.title', {
        ns: 'entities'
      }),
    reference: {
      content: (t) =>
        t(
          'block.ActionUserInput.parseAttachmentsCountTypeEntities.float.reference',
          {
            ns: 'entities'
          }
        )
    }
  }
};

export interface IParseAllMessage {
  commonSavingParams: ICommonSavingParams;
  formatSavingParams: IParseMessageGroup;
}

export interface ICommonSavingParams {
  target: IField<string | null>;
}

export type MapParseDateFilterToFormat = {
  [ParseMessageFilterType.date]: ParseMessageDateFilterFormat;
  [ParseMessageFilterType.datetime]: ParseMessageDateTimeFilterFormat;
  [ParseMessageFilterType.time]: ParseMessageTimeFilterFormat;
};
export interface IParseMessageDateFilter<K extends ParseMessageDateFilterType> {
  kind: K;
  format: IField<MapParseDateFilterToFormat[K]>;
}

export const dateFilterFormats = [
  ParseMessageDateFilterFormat.dayMonthYear,
  ParseMessageDateFilterFormat.dayMonthYearWithSlash,
  ParseMessageDateFilterFormat.dateWithSlash
];

export const dateTimeFilterFormats = [
  ParseMessageDateTimeFilterFormat.dayMonthYearWithTime,
  ParseMessageDateTimeFilterFormat.dayMonthYearTimeWithSlash,
  ParseMessageDateTimeFilterFormat.dateTimeWithSlash
];

export const timeFilterFormats = [
  ParseMessageTimeFilterFormat.time,
  ParseMessageTimeFilterFormat.timeWithSec
];

export const mapParseMessageDateFilterFormatToTitle: Record<
  | ParseMessageDateFilterFormat
  | ParseMessageDateTimeFilterFormat
  | ParseMessageTimeFilterFormat,
  string
> = {
  [ParseMessageDateFilterFormat.dayMonthYear]: 'DD.MM.YYYY',
  [ParseMessageDateFilterFormat.dayMonthYearWithSlash]: 'DD/MM/YYYY',
  [ParseMessageDateFilterFormat.dateWithSlash]: 'MM/DD/YYYY',
  [ParseMessageDateTimeFilterFormat.dayMonthYearWithTime]: 'DD.MM.YYYY HH:MM',
  [ParseMessageDateTimeFilterFormat.dayMonthYearTimeWithSlash]:
    'DD/MM/YYYY HH:MM',
  [ParseMessageDateTimeFilterFormat.dateTimeWithSlash]: 'MM/DD/YYYY HH:MM',
  [ParseMessageTimeFilterFormat.time]: 'HH:MM',
  [ParseMessageTimeFilterFormat.timeWithSec]: 'HH:MM:SS'
};
